import Header from "../../components/Layouts/Header";
import Confirmation from "../../components/BuyCredit/Confirmation";
import BottomBar from "../../components/Layouts/BottomBar";
import PricingFooter from "../../components/Layouts/PricingFooter";
import "../../components/BuyCredit/Pricing.css";

const ConfirmationPage = () => {
  return (
    <>
      <div className="billing_page_layout">
        <Header />
        <Confirmation />
        <BottomBar className="bottom-bar-spacing" />
        <PricingFooter />
      </div>
    </>
  );
};

export default ConfirmationPage;
